import axios from 'axios'
import { navigation } from '@carrent/platform'
import { getAccessToken, getRefreshToken, setTokens, clearTokens,
         getDeviceId, getSessionId, newRequestId } from './tokens'

// Относительные URL — запросы идут через прокси (Vite в dev, nginx в prod).

/** Куда уводить при протухшей сессии. Задаёт приложение. */
let loginPath = '/login'
export const setLoginPath = (p) => { loginPath = p }
const redirectToLogin = () => navigation.replaceLocation(loginPath)

// Заполняется приложением при старте через setClientInfo().
let clientInfo = { app: 'unknown', version: '0.0.0' }

/** @param {{ app: 'driver'|'console', version: string }} info */
export function setClientInfo(info) {
  clientInfo = { ...clientInfo, ...info }
}

export const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  const token = getAccessToken()
  if (token) config.headers.Authorization = `Bearer ${token}`

  // Сквозные идентификаторы для четырёх потоков логирования.
  config.headers['X-Request-Id'] = newRequestId()
  config.headers['X-Client-App'] = clientInfo.app
  config.headers['X-Client-Ver'] = clientInfo.version
  config.headers['X-Device-Id'] = getDeviceId()
  config.headers['X-Session-Id'] = getSessionId()

  // Когда действие произошло на устройстве.
  //
  // Для обычного запроса совпадает с моментом отправки. Для действия
  // из офлайн-очереди (фича 1) — это время, когда водитель реально
  // нажал кнопку, и оно может отличаться на часы. Ставим здесь,
  // чтобы вызывающий код не помнил про офлайн: очередь переопределяет
  // заголовок при повторной отправке.
  if (!config.headers['X-Client-Time']) {
    config.headers['X-Client-Time'] = new Date().toISOString()
  }
  return config
})

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true
      const refresh = getRefreshToken()
      if (refresh) {
        try {
          const { data } = await axios.post(
            '/api/auth/refresh',
            {},
            { headers: { Authorization: `Bearer ${refresh}` } }
          )
          const newToken = data.data?.access_token || data.access_token
          setTokens(newToken)
          original.headers.Authorization = `Bearer ${newToken}`
          return api(original)
        } catch {
          clearTokens()
          redirectToLogin()
        }
      } else {
        redirectToLogin()
      }
    }
    return Promise.reject(err)
  }
)

export default api
